/* tslint:disable */
/* eslint-disable */
/* @relayHash 76e49b87e5d01c37184fce582e0cb0a1 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileRootQueryVariables = {
    firmUrlLabel: string;
    shouldRenderOverview: boolean;
    shouldRenderProjects: boolean;
    isEditMode: boolean;
};
export type ProfileRootQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"DesignProfileWrapper_viewer">;
    };
};
export type ProfileRootQuery = {
    readonly response: ProfileRootQueryResponse;
    readonly variables: ProfileRootQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "firmUrlLabel",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "shouldRenderOverview",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "shouldRenderProjects",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isEditMode",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "urlLabel",
  "variableName": "firmUrlLabel"
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "urlLabel",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "profileStatus",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "about",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v10 = [
  (v4/*: any*/),
  (v3/*: any*/),
  (v9/*: any*/),
  (v5/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v14 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount",
    "args": null,
    "storageKey": null
  }
],
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "addressDisplayString",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "rootId",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "coverPhoto",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "visibility",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "Condition",
  "passingValue": true,
  "condition": "isEditMode",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "editModeDesignProjects",
      "name": "designProjects",
      "storageKey": "designProjects(status:[\"ACTIVE\",\"PENDING\"],visibility:[\"Y\",\"N\"])",
      "args": [
        {
          "kind": "Literal",
          "name": "status",
          "value": [
            "ACTIVE",
            "PENDING"
          ]
        },
        {
          "kind": "Literal",
          "name": "visibility",
          "value": [
            "Y",
            "N"
          ]
        }
      ],
      "concreteType": "designProject",
      "plural": true,
      "selections": [
        (v9/*: any*/),
        (v18/*: any*/),
        (v4/*: any*/),
        (v3/*: any*/),
        (v15/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "internalEditUrl",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "editUrl",
          "args": null,
          "storageKey": null
        },
        (v16/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "tradeCoverPhoto",
          "storageKey": null,
          "args": null,
          "concreteType": "TradePhoto",
          "plural": false,
          "selections": [
            (v11/*: any*/),
            (v5/*: any*/)
          ]
        },
        (v5/*: any*/)
      ]
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ProfileRootQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "DesignProfileWrapper_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ProfileRootQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirms",
            "storageKey": null,
            "args": (v2/*: any*/),
            "concreteType": "TradeFirmType",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "publicProfile",
                "storageKey": null,
                "args": null,
                "concreteType": "TradeFirmPublicProfileType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "address",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Address",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "city",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "state",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "country",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "zipCode",
                        "args": null,
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "designProjectsCount",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "portfolios",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfolioV1",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "itemCount",
                        "args": null,
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "email",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "profilePhoto",
                    "args": null,
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "splashPhotoId",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "splashPhoto",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "profilePhotoId",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              (v7/*: any*/),
              (v5/*: any*/),
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isEditMode",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "publicProfile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TradeFirmPublicProfileType",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "designProjectsCover",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DesignProjectCover",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "portfolios",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioV1",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": "tradePortfolioInstagram",
            "name": "featureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "tradePortfolioInstagram"
              }
            ],
            "storageKey": "featureFlag(feature:\"tradePortfolioInstagram\")"
          },
          (v5/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isEditMode",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "geography",
                "storageKey": null,
                "args": null,
                "concreteType": "Geography",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "countries",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "GeographyObject",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "abbreviation",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "designAwardsQuery",
                "storageKey": null,
                "args": null,
                "concreteType": "AwardType",
                "plural": true,
                "selections": (v10/*: any*/)
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "shouldRenderOverview",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tradeFirms",
                "storageKey": null,
                "args": (v2/*: any*/),
                "concreteType": "TradeFirmType",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "publicProfile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TradeFirmPublicProfileType",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "awards",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AwardType",
                        "plural": true,
                        "selections": (v10/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "articles",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DesignFirmArticleType",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "photo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Photo",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v11/*: any*/),
                              (v5/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "description",
                            "args": null,
                            "storageKey": null
                          },
                          (v12/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "webLink",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "WebLink",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "webLinks",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WebLinkType",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "facebook",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "instagram",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "pinterest",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "website",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "portfoliosInflated",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioV2",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "items",
                            "storageKey": "items(first:6)",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 6
                              }
                            ],
                            "concreteType": "PortfolioItemsConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PortfolioItemsEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PortfolioItemV2",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "item",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Item",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "firstPhotoWebPath",
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "size",
                                                "value": "thumb"
                                              }
                                            ],
                                            "storageKey": "firstPhotoWebPath(size:\"thumb\")"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "localizedPdpUrl",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          (v12/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "seller",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Seller",
                                            "plural": false,
                                            "selections": [
                                              (v4/*: any*/),
                                              (v5/*: any*/)
                                            ]
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "isContemporary",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "isCustomizable",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "isNewAndMadeToOrder",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "classification",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ItemClassification",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "categories",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "ItemCategory",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "category",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Category",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "key",
                                                        "args": null,
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "browseUrl",
                                                        "args": null,
                                                        "storageKey": null
                                                      },
                                                      (v5/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "pricing",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ItemPricing",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "amount",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "FinancialAmount",
                                                "plural": false,
                                                "selections": (v14/*: any*/)
                                              },
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "netPrice",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "FinancialAmount",
                                                "plural": false,
                                                "selections": (v14/*: any*/)
                                              },
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "salePrice",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "FinancialAmount",
                                                "plural": false,
                                                "selections": (v14/*: any*/)
                                              }
                                            ]
                                          },
                                          (v5/*: any*/)
                                        ]
                                      },
                                      (v5/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "kind": "Condition",
                        "passingValue": false,
                        "condition": "isEditMode",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": "liveDesignProjects",
                            "name": "designProjectsCover",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DesignProjectCover",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              (v15/*: any*/),
                              (v3/*: any*/),
                              (v16/*: any*/),
                              (v9/*: any*/),
                              (v17/*: any*/),
                              (v13/*: any*/),
                              (v18/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v19/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "instagram",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "InstagramFeedType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "feed",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "InstagramFeedItemType",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "imageUrl",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "link",
                            "args": null,
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "kind": "Condition",
                        "passingValue": true,
                        "condition": "isEditMode",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "username",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "__id",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "shouldRenderProjects",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "designFirm",
                "name": "tradeFirms",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "pageSize",
                    "value": 1
                  },
                  (v1/*: any*/)
                ],
                "concreteType": "TradeFirmType",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "publicProfile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TradeFirmPublicProfileType",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "Condition",
                        "passingValue": false,
                        "condition": "isEditMode",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": "liveDesignProjects",
                            "name": "designProjectsCover",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DesignProjectCover",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              (v15/*: any*/),
                              (v3/*: any*/),
                              (v16/*: any*/),
                              (v9/*: any*/),
                              (v17/*: any*/),
                              (v13/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v19/*: any*/)
                    ]
                  },
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ProfileRootQuery",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/ProfileRootQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '0ef0798500544a65def2b10e934aadc8';
export default node;
